import { Route } from '@angular/router';

import { externalUserGuard } from './guards/external-user.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('@esp-enrollment-form/feature-form-welcome').then(
        (m) => m.FeatureFormWelcomeComponent,
      ),
    canActivate: [externalUserGuard],
    pathMatch: 'full',
  },
  {
    path: 'enrollment-scenario',
    loadComponent: () =>
      import('@esp-enrollment-form/feature-form-welcome').then(
        (m) => m.EnrollmentScenarioComponent,
      ),
    canActivate: [externalUserGuard],
  },
  {
    path: 'success',
    loadComponent: () =>
      import('@esp-enrollment-form/feature-form-welcome').then(
        (m) => m.SuccessConfirmationComponent,
      ),
    canActivate: [externalUserGuard],
  },
  {
    path: 'form',
    loadComponent: () =>
      import('@esp-enrollment-form/feature-form-wrapper').then(
        (m) => m.FeatureFormWrapperComponent,
      ),
    canActivate: [externalUserGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/not-found.component').then((m) => m.NotFoundComponent),
  },
];
